var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-2/5 lg:w-1/4 xl:w-1/4 mx-auto"},[_c('FichaAsesor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }